import React, { useState, useEffect } from "react";
import { Navbar, Button } from "../components/indexComponents";
import { useUser } from "../components/accounts/UserProvider";
import "../CSS/Settings.css";

function Settings() {
  const [mainHue, setmainHue] = useState();
  const [mainPourcentage, setMainPourcentage] = useState();
  const [mainBrightness, setMainBrightness] = useState();
  const [secondHue, setSecondHue] = useState();
  const [secondPourcentage, setSecondPourcentage] = useState();
  const [secondBrightness, setSecondBrightness] = useState();
  const [loading, setLoading] = useState(true);
  const [saveMessage, setSaveMessage] = useState("");
  const { user } = useUser();

  /* #region  Color */
  useEffect(() => {
    if (user) {
      if (user.Colors) {
        setmainHue(user.Colors[0]);
        setMainPourcentage(user.Colors[1]);
        setMainBrightness(user.Colors[2]);
        setSecondHue(user.Colors[3]);
        setSecondPourcentage(user.Colors[4]);
        setSecondBrightness(user.Colors[5]);
        setLoading(false);
      } else {
        setmainHue("219");
        setMainPourcentage("45");
        setMainBrightness("40");
        setSecondHue("187");
        setSecondPourcentage("80");
        setSecondBrightness("35");
        setLoading(false);
      }
    } else {
      setmainHue("219");
      setMainPourcentage("45");
      setMainBrightness("40");
      setSecondHue("187");
      setSecondPourcentage("80");
      setSecondBrightness("35");
      setLoading(false);
    }
  }, [user]);

  const handleChangeMainColor = (e) => {
    const newColor = e.target.value;
    setmainHue(newColor);
    document.documentElement.style.setProperty("--main-hue", newColor);
  };
  const handleChangeMainContrast = (e) => {
    const newPourcentage = e.target.value;
    setMainPourcentage(newPourcentage);
    const newColor = newPourcentage + "%";
    document.documentElement.style.setProperty("--main-contrast", newColor);
  };
  const handleChangeMainBrightness = (e) => {
    const newPourcentage = e.target.value;
    setMainBrightness(newPourcentage);
    const newColor = newPourcentage + "%";
    document.documentElement.style.setProperty("--main-brightness", newColor);
  };
  const handleChangeSecondColor = (e) => {
    const newColor = e.target.value;
    setSecondHue(newColor);
    document.documentElement.style.setProperty("--secondary-hue", newColor);
  };
  const handleChangeSecondContrast = (e) => {
    const newPourcentage = e.target.value;
    setSecondPourcentage(newPourcentage);
    const newColor = newPourcentage + "%";
    document.documentElement.style.setProperty(
      "--secondary-contrast",
      newColor
    );
  };
  const handleChangeSecondBrightness = (e) => {
    const newPourcentage = e.target.value;
    setSecondBrightness(newPourcentage);
    const newColor = newPourcentage + "%";
    document.documentElement.style.setProperty(
      "--secondary-brightness",
      newColor
    );
  };
  const setDefault = () => {
    setmainHue("219");
    setMainPourcentage("45");
    setMainBrightness("40");
    setSecondHue("187");
    setSecondPourcentage("80");
    setSecondBrightness("35");
  };
  const createColors = () => {
    const colors = [
      mainHue,
      mainPourcentage,
      mainBrightness,
      secondHue,
      secondPourcentage,
      secondBrightness,
    ];
    handleSave(colors);
    setSaveMessage("Sauvegardé!");
    setTimeout(() => {
      setSaveMessage("");
    }, 2000);
  };
  const handleSave = async (colors) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/user`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ Colors: colors }),
    });

    if (!response) {
      console.log("Something went wrong");
    }
  };
  /* #endregion */
  return (
    <div className="page-frame Settings">
      <Navbar />
      <div className="page-content">
        {!loading ? (
          <>
            <h1>Paramètres</h1>
            <div className="color-setting flex-left col ">
              <h2 className="setting-tab-title">Couleurs :</h2>
              <ul className="setting-list">
                <li className="flex gap-15 align-center">
                  <h3 className="fw-300 h3 main-color">Couleur Principale :</h3>
                  <div className="flex color-container">
                    <label htmlFor="">
                      Couleur
                      <div className="flex align-center gap-15">
                        <input
                          type="range"
                          value={mainHue}
                          onChange={handleChangeMainColor}
                          min="0"
                          max="355"
                        />
                        <input
                          type="text"
                          className="indicator"
                          value={mainHue}
                          onChange={handleChangeMainColor}
                        />
                      </div>
                    </label>
                    <label htmlFor="">
                      Contraste
                      <div className="flex align-center gap-15">
                        <input
                          type="range"
                          value={mainPourcentage}
                          onChange={handleChangeMainContrast}
                          min="0"
                          max="100"
                        />
                        <input
                          type="text"
                          className="indicator"
                          value={mainPourcentage}
                          onChange={handleChangeMainContrast}
                        />
                      </div>
                    </label>
                    <label htmlFor="">
                      Luminosité
                      <div className="flex align-center gap-15">
                        <input
                          type="range"
                          value={mainBrightness}
                          onChange={handleChangeMainBrightness}
                          min="0"
                          max="100"
                        />
                        <input
                          type="text"
                          className="indicator"
                          value={mainBrightness}
                          onChange={handleChangeMainBrightness}
                        />
                      </div>
                    </label>
                  </div>
                </li>
                <li className="flex gap-15 align-center secondary-color">
                  <h3 className="fs-0 fw-300 secondary-color h3">
                    Couleur Secondaire :
                  </h3>
                  <div className="flex color-container">
                    <label htmlFor="">
                      Couleur
                      <div className="flex align-center gap-15">
                        <input
                          type="range"
                          value={secondHue}
                          onChange={handleChangeSecondColor}
                          min="0"
                          max="355"
                        />
                        <input
                          type="text"
                          className="indicator"
                          value={secondHue}
                          onChange={handleChangeSecondColor}
                        />
                      </div>
                    </label>
                    <label htmlFor="">
                      Contraste
                      <div className="flex align-center gap-15">
                        <input
                          type="range"
                          value={secondPourcentage}
                          onChange={handleChangeSecondContrast}
                          min="0"
                          max="100"
                        />
                        <input
                          type="text"
                          className="indicator"
                          value={secondPourcentage}
                          onChange={handleChangeSecondContrast}
                        />
                      </div>
                    </label>
                    <label htmlFor="">
                      Luminosité
                      <div className="flex align-center gap-15">
                        <input
                          type="range"
                          value={secondBrightness}
                          onChange={handleChangeSecondBrightness}
                          min="0"
                          max="100"
                        />
                        <input
                          type="text"
                          className="indicator"
                          value={secondBrightness}
                          onChange={handleChangeSecondBrightness}
                        />
                      </div>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div className="btn-actions">
              <Button
                text="Par Défaut"
                className="default-btn"
                onClick={setDefault}
              />
              <div className="save-btn-container">
                <p className="save-msg">{saveMessage}</p>
                <Button
                  text="Sauvegarder"
                  className="save-btn"
                  onClick={createColors}
                />
              </div>
            </div>
          </>
        ) : (
          <div>Chargement des paramètres...</div>
        )}
      </div>
    </div>
  );
}

export default Settings;
